import {announce} from '@github-ui/aria-live'
import {UnsafeHTMLText} from '@github-ui/safe-html/UnsafeHTML'
import {testIdProps} from '@github-ui/test-id-props'
import {useAnalytics} from '@github-ui/use-analytics'
import {Banner} from '@primer/react'
import {useEffect} from 'react'

import {Strings} from './constants/strings'
import styles from './ValidationMessage.module.css'

interface ValidationMessageProps {
  id: string
  messages?: string[]
}

export const ValidationMessage = ({id, messages}: ValidationMessageProps) => {
  const {sendAnalyticsEvent} = useAnalytics()
  useEffect(() => {
    if (messages && messages.length > 0) {
      const userFriendlyMessage = messages
        .map(s => s.replaceAll(/<pre>|<\/pre>/g, "'"))
        .join('. ')
        .trim()
      const announcement = `${Strings.filterInvalid(messages.length)} ${userFriendlyMessage}.`
      announce(announcement)
      sendAnalyticsEvent('filter.validation_errors', 'FILTER_VALIDATION_ERRORS', {messages: userFriendlyMessage})
    }
  }, [sendAnalyticsEvent, messages])

  if (!messages || messages.length < 1) return null

  return (
    <Banner id={id} variant="warning" className={styles.Banner}>
      <Banner.Title>
        <span {...testIdProps('validation-error-count')}>{Strings.filterInvalid(messages.length)}</span>
      </Banner.Title>
      <div className={styles.Box_0}>
        <ul className={styles.Box_2} {...testIdProps('validation-error-list')}>
          {messages.map(message => (
            <li key={message.replaceAll(' ', '-')}>
              <UnsafeHTMLText
                html={message}
                domPurifyConfig={{ALLOWED_TAGS: ['pre'], ALLOWED_ATTR: [], ALLOW_DATA_ATTR: false}}
                className={styles.VerifiedHTMLBox_0}
              />
            </li>
          ))}
        </ul>
      </div>
    </Banner>
  )
}
